import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import NavMenu from './nav-menu';
import DownIcon from 'grommet/components/icons/base/Down';
import Utils from 'medscape/utils';
import Link from './link';
export default class NavItem extends React.Component {
    constructor(props){
        super(props);
        this.state={
            isExpanded: false
        }
        this.hasSubmenu = (props.item.submenu && props.item.submenu.length>0);
    }

    componentDidMount() {
        //let $this = $(ReactDOM.findDOMNode(this));
        this.checkItem();
    } // componentDidMount
    componentDidUpdate(){
        this.checkItem();
    }
    checkItem(){
        if(this.hasSubmenu && this.props.settings.submenuType && this.props.settings.submenuType=="default" && this.props.settings.position!="top"){
            let hasActive = false;
            let routeLocation = this.props.route.location.pathname;
            let routeItem = this.props.item.submenu.find( (navItem)=>{
                return navItem.url == routeLocation;
            });
            if(routeItem!=null){
                this.setState({
                    isExpanded: true
                })
            }
        }
    }
    toggleSubmenu(e,itemData){
        const hash = window.location.hash;
        if (hash) {
          const element = document.querySelector(hash);
          if (element) {
            $('html, body').animate({
                scrollTop: $(element).offset().top
            }, 2000);
          }
        }
        this.props.onItemClick(this); 
    }
    
    render(){
        const data = this.props.item;
        const route = this.props.route;
        let itemName  = this.props['item-name'];
        let isActive = route.location.pathname==data.url;
        let _itemClass = cx({
            'submenu-parent': this.hasSubmenu,
            'active-page': isActive,
            'expand-submenu': this.state.isExpanded,
            'layered-submenu': this.hasSubmenu && this.props.settings.submenuType=='layer'
        })
        const LinkProps = {
            item: this.props.item,
            onToggleSubmenu: this.toggleSubmenu.bind(this),
            isExpandedSubmenu: this.state.isExpanded,
            position: this.props.settings.position,
            submenuType: this.props.settings.submenuType
        }
        if(this.hasSubmenu){
            let itemProps = {
                className: _itemClass,
                onMouseEnter: (e)=>{
                    this.props.onMouseEnter(this);
                },
                onMouseLeave: (e)=>{
                    this.props.onMouseLeave(this);
                }

            }

            let NavMenuProps = {
                items: data.submenu,
                settings: this.props.settings,
                route: this.props.route,
                isSubmenu: true,
                onItemClick: this.props.onItemClick
            }

            return(
                <li {...itemProps}>
                    <Link {...LinkProps} />
                    <NavMenu {...NavMenuProps}></NavMenu>
                </li>
            );
        }
        else{
            return(
                <li className={_itemClass}>
                    <Link {...LinkProps} />
                </li>
            );
        }
    } // render()
} // ListItem
NavItem.propTypes={
    item: React.PropTypes.object.isRequired,
    settings: React.PropTypes.object.isRequired,
    route: React.PropTypes.object.isRequired,
    isSubmenuItem: React.PropTypes.bool,
    onItemClick: React.PropTypes.func,
    onMouseEnter: React.PropTypes.func,
    onMouseLeave: React.PropTypes.func
}
NavItem.defaultProps={
    isSubmenuItem: false,
    onItemClick: ()=>{},
    onMouseLeave: ()=>{},
    onMouseEnter: ()=>{}
}



// WEBPACK FOOTER //
// ./src/app/navigation/nav-item.jsx